<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="商品一名称：" prop="goods_name1">
                <el-input v-model="model.goods_name1"></el-input>
            </el-form-item>
            <el-form-item label="商品一图片：" prop="goods_img1" class="share_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess1"
                    :before-upload="beforeUpload">
                    <img v-if="model.goods_img1" :src="model.goods_img1" class="upImg" style="width: 200px;height: 200px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 200px;height: 200px;line-height: 200px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 500px</span>
            </el-form-item>
            <el-form-item label="商品一链接：" prop="goods_link1">
                <el-input v-model="model.goods_link1"></el-input>
            </el-form-item>
            <el-form-item label="商品二名称：" prop="goods_name2">
                <el-input v-model="model.goods_name2"></el-input>
            </el-form-item>
            <el-form-item label="商品二图片：" prop="goods_img2" class="share_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess2"
                    :before-upload="beforeUpload">
                    <img v-if="model.goods_img2" :src="model.goods_img2" class="upImg" style="width: 200px;height: 200px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 200px;height: 200px;line-height: 200px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 500px</span>
            </el-form-item>
            <el-form-item label="商品二链接：" prop="goods_link2">
                <el-input v-model="model.goods_link2"></el-input>
            </el-form-item>
            <el-form-item label="是否显示：" prop="show_state">
                <el-select clearable v-model="model.show_state" placeholder="请选择">
                    <el-option v-for="item in enuObj('show_state')" :key="'show_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import config from '@/config'

export default {
    name: 'momentAdEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                goods_name1: '',
                goods_img1: '',
                goods_link1: '',
                goods_name2: '',
                goods_img2: '',
                goods_link2: '',
                show_state: '',
            },
            getObj:{
                url:'/api/admin/momentad/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['show_state'],
            rules: {
                goods_name1: [
                    {required: true, message: '商品一名称不能为空', trigger: 'blur'}
                ],
                goods_img1: [
                    {required: true, message: '商品一图片不能为空', trigger: 'blur'}
                ],
                goods_link1: [
                    {required: true, message: '商品一链接不能为空', trigger: 'blur'}
                ],
                goods_name2: [
                    {required: true, message: '商品二名称不能为空', trigger: 'blur'}
                ],
                goods_img2: [
                    {required: true, message: '商品二图片不能为空', trigger: 'blur'}
                ],
                goods_link2: [
                    {required: true, message: '商品二链接不能为空', trigger: 'blur'}
                ],
                show_state: [
                    {required: true, message: '是否显示不能为空', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "raffle",
            },
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/momentad/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess1(res, file){
            if(res.code ==1){
                this.model.goods_img1 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess2(res, file){
            if(res.code ==1){
                this.model.goods_img2 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        formateData(){
            this.model.show_state = this.model.show_state+""
        }
    }
};
</script>